var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLocale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30a1,1,0,0,1-1-1V3a1,1,0,0,1,2,0V29A1,1,0,0,1,16,30Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17a1,1,0,0,1-1-1c0-6.5-2.75-12-6-12a1,1,0,0,1,0-2c4.49,0,8,6.15,8,14A1,1,0,0,1,23,17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30a1,1,0,0,1,0-2c3.25,0,6-5.5,6-12a1,1,0,0,1,2,0C24,23.85,20.49,30,16,30Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9,17a1,1,0,0,1-1-1C8,8.15,11.51,2,16,2a1,1,0,0,1,0,2c-3.25,0-6,5.5-6,12A1,1,0,0,1,9,17Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-4.49,0-8-6.15-8-14a1,1,0,0,1,2,0c0,6.5,2.75,12,6,12a1,1,0,0,1,0,2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29,17H3a1,1,0,0,1,0-2H29a1,1,0,0,1,0,2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11H5A1,1,0,0,1,5,9H27a1,1,0,0,1,0,2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27,23H5a1,1,0,0,1,0-2H27a1,1,0,0,1,0,2Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocale);
export default __webpack_public_path__ + "static/media/icon-locale.576af56c.svg";
export { ForwardRef as ReactComponent };